<template>
  <div class="common-layout">
    <!-- 菜单导航 -->
    <div id="header" :class="{'extra_class': isAddExtraClass}" v-if="showHeader">
      <div class="header">
        <div class="left" @click="goPath('/mobile/home')">
          <img alt="未来网络学堂" :src="require('/src/assets/img/logo/fnedu.png')" v-if="!isAddExtraClass">
          <img alt="未来网络学堂" :src="require('/src/assets/img/logo/fnedu_admin.png')" v-else>
        </div>
        <div class="right">
          <div class="search">
            <van-search ref="searchCur" v-model="searchInput" placeholder="请输入搜索关键词" show-action  @search="onSearch" @cancel="isShowSearch=false" v-if="isShowSearch" />
            <van-icon name="search" size="21" v-if="!isShowSearch" @click="showSearch" />
          </div>
          <div class="cart" v-if="!user.is_authenticated && !isShowSearch" @click="loginModal.visible = true">
            <van-icon name="shopping-cart-o" size="21" :dot="cartItemCount > 0" />
          </div>
          <div class="cart" v-if="user.is_authenticated && !isShowSearch" @click="goPath('/mobile/cart')">
            <van-icon name="shopping-cart-o" size="21" :dot="cartItemCount > 0" />
          </div>
          <div class="login" v-if="!user.is_authenticated && !isShowSearch" @click="loginModal.visible = true">登录/注册</div>
          <van-image v-if="user.is_authenticated && !isShowSearch"
            round
            width="30px"
            height="30px"
            :src="imgDataUrl"
            class="avatar"
            @click="toCenterPage"
          />
          <div class="menu" @click="showMenu = !showMenu" v-if="!isShowSearch">
            <van-icon name="bars" size="21" v-if="!showMenu" />
            <van-icon name="cross" size="21" v-if="showMenu" />
          </div>
        </div>
      </div>
    </div>
    <transition name="van-slide-down" mode="out-in" appear>
      <div class="menu_list" v-show="showMenu">
        <ul>
          <li v-for="(item, index) in navData" :key="index" :class="{'active': `/mobile${item.path}` === activeIndex}">
            <a class="menu_item test"  href="javascript:;" @click="goNav(item)">{{ item.name }}</a>
<!--            <router-link v-else :to="`/mobile${item.path}`" class="menu_item" :target="item.open_mode === 2 ? '_blank' : ''"  @click="goNav(item)">{{ item.name }}</router-link>-->
<!--            <a v-if="item.link_url && item.link_url !== ''" class="menu_item" :href="`${item.link_url}`" :target="item.open_mode === 2 ? '_blank' : ''"  @click="goNav(item)">{{ item.name }}</a>-->
<!--            <router-link v-else :to="`/mobile${item.path}`" class="menu_item" :target="item.open_mode === 2 ? '_blank' : ''"  @click="goNav(item)">{{ item.name }}</router-link>-->
          </li>
<!--          <li :class="{'active': activeIndex === '/mobile/certificatequery'}">-->
<!--            <router-link to="/mobile/certificatequery" @click="showMenu = false">证书查询</router-link>-->
<!--          </li>-->
<!--          <li :class="{'active': activeIndex === '/mobile/aboutus'}">-->
<!--            <router-link to="/mobile/aboutus" @click="showMenu = false">关于我们</router-link>-->
<!--          </li>-->
        </ul>
      </div>
    </transition>
    <!-- 主内容 -->
    <div :class="{ 'main':true, 'full_h': isMainFullHeight }">
      <router-view v-slot="{ Component }"
                    v-model:loginVisible="loginModal.visible"
                    v-model:cartItemCount="cartItemCount"
                    v-model:isShowHeader="showHeader"
                    v-model:isAddExtraClass="isAddExtraClass"
                    v-model:isShowOverlay="isShowOverlay"
                    v-model:isMainFullHeight="isMainFullHeight"
                    v-model:showFooter="showFooter">
         <component :is="Component"></component>
      </router-view>
    </div>
    <!-- 底栏 -->
    <div id="footer" v-if="showFooter">
      Copyright ©2014-2024 江苏致网科技有限公司 版权所有 <br /> <a href="https://beian.miit.gov.cn/">苏ICP备13052757号-5</a>
    </div>

    <!-- 登录/注册 -->
    <van-popup v-model:show="loginModal.visible" position="right" :style="{ width: '100%', height: '100%' }" @close="closeLoginModal">
      <van-nav-bar
        z-index="10"
        left-arrow
        :title="loginModal.isLogin ? '登录' : '注册'"
        :right-text="loginModal.isLogin ? '注册' : '登录'"
        @click-left="loginModal.visible = false;"
        @click-right="loginClickRightHandler()" />
      <div v-if="loginModal.visible">
        <!-- 登录 -->
        <div v-if="loginModal.isLogin">
          <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="loginModal.login_error">{{ loginModal.login_error }}。</van-notice-bar>
          <van-form class="log_form" ref="loginForm">
            <van-cell-group>
              <van-cell>用户登录</van-cell>
              <van-field
                v-model="loginModal.loginForm.tel"
                placeholder="请输入手机号/用户名/邮箱"
                :rules="rules.tel"
              />
              <PwdInput v-model:pwd="loginModal.loginForm.pwd" :rules="rules.pwd" />
              <!-- 校验 -->
              <van-field :rules="rules.verify" v-model="loginModal.loginForm.verify" class="slider_verify">
                <template #input>
                  <div style="width:100%;">
                    <SliderVerify @result="getLoginResult"></SliderVerify>
                  </div>
                </template>
              </van-field>
              <van-cell class="extra" v-if="!useCookie">
                <template #title>
                  <span style="color: red;">您的手机浏览器不支持或已经禁用cookie,无法正常登录,请开启或更换其他浏览器</span>
                </template>
              </van-cell>
              <van-cell class="extra">
                <template #title>
                  <van-button block type="primary" @click="submitLoginForm()">立即登录</van-button>
                </template>
              </van-cell>
              <van-cell class="extra">
                <template #title>
                  <van-checkbox shape="square" icon-size="14" v-model="loginModal.loginForm.autoLogin">下次自动登录</van-checkbox>
                </template>
                <template #value>
                  <a href="javascript:;" @click="showForgetPwd">忘记密码？</a>
                </template>
              </van-cell>
            </van-cell-group>
          </van-form>
          <van-divider :style="{ color: '#666', borderColor: '#333', padding: '0 16px', width: '80%', margin: '10px auto 20px' }">第三方账户登录</van-divider>
          <div class="third_login">
            <a href="#" @click="startThirdPartyLogin('qq')"><i class="iconfont icon-111_huaban1" style="color:#18acfc;"></i></a>
            <a href="#" v-if="false" @click="startThirdPartyLogin('weixin')"><i class="iconfont icon-111-02" style="color:#00bb29;"></i></a>
            <a href="#" @click="startThirdPartyLogin('weibo')"><i class="iconfont icon-111-03" style="color:#d72b2b;"></i></a>
            <a href="#" @click="startThirdPartyLogin('baidu')"><i class="iconfont icon-111-04" style="color:#306cff;"></i></a>
            <a href="#" @click="startThirdPartyLogin('github')"><i class="iconfont icon-111-05" style="color:#1f76b6;"></i></a>
          </div>
        </div>
        <!-- 注册 -->
        <div v-else>
          <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="loginModal.register_error">{{ loginModal.register_error }}。</van-notice-bar>
          <van-form class="log_form" ref="registerForm">
            <van-cell-group>
              <van-cell>用户注册</van-cell>
              <van-field class="field_tel"
                v-model="loginModal.registerForm.register_tel"
                name="register_tel"
                type="tel"
                label="CN+86"
                placeholder="请输入手机号"
                :rules="rules.register_tel"
              />
              <PwdInput v-model:pwd="loginModal.registerForm.register_pwd" :rules="rules.register_pwd" name="register_pwd" />
              <!-- 校验 -->
              <van-field class="field_image_yzm"
                v-model="loginModal.registerForm.image_yzm"
                name="image_yzm"
                placeholder="请输入图形验证码"
                :rules="rules.image_yzm"
              >
                <template #button>
                  <img :src="loginModal.register_sms_image" @click="getImageCaptcha((sms_key, img_src) => {
                    loginModal.register_sms_key = sms_key
                    loginModal.register_sms_image = img_src
                  })" />
                </template>
              </van-field>
              <van-field v-if="!loginModal.isVerify"
                v-model="loginModal.registerForm.yzm"
                :placeholder="loginModal.registerForm.yzm_placeholder"
                :rules="rules.yzm"
              >
                <template #button>
                  <van-button size="small" type="primary" v-if="!loginModal.isGetYzm" @click="getSms()">获取验证码</van-button>
                  <van-button size="small" type="primary" disabled v-else>{{ loginModal.countdown }}</van-button>
                </template>
              </van-field>
              <!-- 校验 -->
              <!-- <van-field v-else :rules="rules.verify" class="slider_verify">
                <template #input>
                  <div style="width:100%;">
                    <SliderVerify @result="getRegisterResult"></SliderVerify>
                  </div>
                </template>
              </van-field> -->
              <van-cell class="extra" v-if="!useCookie">
                <template #title>
                  <span style="color: red;">您的手机浏览器不支持或已经禁用cookie,无法正常登录,请开启或更换其他浏览器</span>
                </template>
              </van-cell>
              <van-cell class="extra">
                <template #title>
                  <van-button block type="primary" @click="submitRegisterForm()">立即注册</van-button>
                </template>
              </van-cell>
              <van-field :rules="rules.agree" class="custom_van_checkbox">
                <template #input>
                  <van-checkbox class="agreement" shape="square" icon-size="16" v-model="loginModal.registerForm.agree">同意<router-link to="/mobile/agreement" target="_blank">《未来网络学堂用户注册使用协议》</router-link> </van-checkbox>
                </template>
              </van-field>
            </van-cell-group>
          </van-form>
        </div>
      </div>
    </van-popup>

    <!-- 忘记密码 -->
    <van-popup v-model:show="forgetPwdModal.visible" position="right" :style="{ width: '100%', height: '100%' }" @close="closeForgetPwdModal">
      <van-nav-bar
        z-index="10"
        left-arrow
        title="忘记密码"
        @click-left="forgetPwdModal.visible = false"></van-nav-bar>
      <div v-if="forgetPwdModal.visible">
        <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="forgetPwdModal.error">{{ forgetPwdModal.error }}。</van-notice-bar>
        <van-form class="log_form" ref="forgetPwdForm">
          <van-cell-group>
            <van-field class="field_tel"
              v-model="forgetPwdModal.form.forget_tel"
              name="forget_tel"
              type="tel"
              label="CN+86"
              placeholder="请输入手机号"
              :rules="rules.forget_tel"
            />
            <PwdInput v-model:pwd="forgetPwdModal.form.pwd" :rules="rules.pwd" placeholder="请输入新密码" name="pwd" />
            <!-- 校验 -->
            <van-field class="field_image_yzm"
              v-model="forgetPwdModal.form.image_yzm"
              name="image_yzm"
              placeholder="请输入图形验证码"
              :rules="rules.image_yzm"
            >
              <template #button>
                <img :src="forgetPwdModal.sms_image" @click="getImageCaptcha((sms_key, img_src) => {
                  forgetPwdModal.sms_key = sms_key
                  forgetPwdModal.sms_image = img_src
                })" />
              </template>
            </van-field>
            <van-field v-if="!forgetPwdModal.isVerify"
              v-model="forgetPwdModal.form.yzm"
              :placeholder="forgetPwdModal.form.yzm_placeholder"
              :rules="rules.yzm"
            >
              <template #button>
                <van-button size="small" type="primary" v-if="!forgetPwdModal.isGetYzm" @click="getForgetSms()">获取验证码</van-button>
                <van-button size="small" type="primary" disabled v-else>{{ forgetPwdModal.countdown }}</van-button>
              </template>
            </van-field>
            <!-- 校验 -->
            <!-- <van-field v-else :rules="rules.verify" class="slider_verify">
              <template #input>
                <div style="width:100%;">
                  <SliderVerify @result="getForgetPwdResult"></SliderVerify>
                </div>
              </template>
            </van-field> -->
            <van-cell class="extra">
              <template #title>
                <van-button block type="primary" @click="submitForgetForm()">确定</van-button>
              </template>
            </van-cell>
          </van-cell-group>
        </van-form>
      </div>
    </van-popup>

    <!-- 补充手机号 -->
    <van-popup v-model:show="addCellPhoneModal.visible" position="right" :style="{ width: '100%', height: '100%' }" @close="closeAddPhoneModal">
      <van-nav-bar
        z-index="10"
        left-arrow
        title="补充手机号码"
        @click-left="addCellPhoneModal.visible = false"></van-nav-bar>
      <van-notice-bar background="#fef0f0" color="#f56c6c" v-if="addCellPhoneModal.error">{{ addCellPhoneModal.error }}。</van-notice-bar>
      <van-form class="log_form" ref="addCellPhoneForm">
        <van-cell-group>
          <van-field class="field_tel"
            v-model="addCellPhoneModal.form.addtel"
            name="addtel"
            type="tel"
            label="CN+86"
            placeholder="请输入手机号"
            :rules="rules.addtel"
          />
          <!-- 校验 -->
          <van-field class="field_image_yzm"
            v-model="addCellPhoneModal.form.image_yzm"
            name="image_yzm"
            placeholder="请输入图形验证码"
            :rules="rules.image_yzm"
          >
            <template #button>
              <img :src="addCellPhoneModal.sms_image" @click="getImageCaptcha((sms_key, img_src) => {
                addCellPhoneModal.sms_key = sms_key
                addCellPhoneModal.sms_image = img_src
              })" />
            </template>
          </van-field>
          <van-field v-if="!addCellPhoneModal.isVerify"
            v-model="addCellPhoneModal.form.yzm"
            :placeholder="addCellPhoneModal.form.yzm_placeholder"
            :rules="rules.yzm"
          >
            <template #button>
              <van-button size="small" type="primary" v-if="!addCellPhoneModal.isGetYzm" @click="getAddSms()">获取验证码</van-button>
              <van-button size="small" type="primary" disabled v-else>{{ addCellPhoneModal.countdown }}</van-button>
            </template>
          </van-field>
          <!-- 校验 -->
          <!-- <van-field v-else :rules="rules.verify" class="slider_verify">
            <template #input>
              <SliderVerify @result="getAddPhoneResult"></SliderVerify>
            </template>
          </van-field> -->
          <van-cell class="extra">
            <template #title>
              <van-button block type="primary" @click="submitAddPhoneForm()">确定</van-button>
            </template>
          </van-cell>
        </van-cell-group>
      </van-form>
    </van-popup>

    <!-- 共用全局遮罩 -->
    <Overlay :isLoad="isShowOverlay"></Overlay>

    <!-- 右侧悬浮列按钮 -->
    <SideBtns></SideBtns>
  </div>
</template>

<script>
import SideBtns from 'components/mobile/common/SideBtns.vue'
import SliderVerify from 'components/mobile/common/SliderVerify'
import ResetPwdModal from 'components/ResetPwdModal.vue'
import PwdInput from 'components/mobile/common/PwdInput'
import Overlay from 'components/mobile/common/Overlay'
import { checkPhone, checkPassword, routePathHandler } from 'utils/mobile/common'
import { showConfirmMessageBox, showMessage } from 'api/base/mobile/message'
import { checkPhoneExist, getSmsCheck, SendSms, RegisterUser } from 'api/user/auth/register'
import { GetUserState, LoginUser, LogOutUser, ThirdPartyLogin, AddCellPhone, ForgetPWD, updateUserLoginState, getDomainSite } from 'api/user/auth/login'
import { countCartItems } from 'api/settlement/cart/user'
import { clickNav } from "api/nav/list"
import { replaceAll } from "api/base/common"
import {setCookie, getCookie} from "api/base/axios";
export default {
    components: {
      SideBtns,
      SliderVerify,
      ResetPwdModal,
      PwdInput,
      Overlay
    },
    props: {
      loginVisible: {
        type: Boolean,
        default: false
      },
    },
    provide() {
        return {
            is_authenticated: this.user.is_authenticated,
            user_id: this.user.user_id,
            user_name: this.user.user_name
        }
    },
    data() {
        let checkPhoneExistRule = (value, rule) => {
          return new Promise(resolve=>{
            checkPhoneExist(value).then((res) => {
              if (!res.result) {
                resolve(true)
              } else {
                resolve('手机号码已经被注册')
              }
            }).catch(err => {
              resolve('服务异常，请稍后再试')
            });
          })
        }

        let checkPhoneNotExistRule = (value, rule) => {
          return new Promise(resolve=>{
            checkPhoneExist(value).then((res) => {
              if (!res.result) {
                resolve('该手机号码不存在')
              } else {
                resolve(true)
              }
            }).catch(err => {
              resolve('服务异常，请稍后再试')
            });
          })
        }

        return {
          isMainFullHeight:false,
          isShowOverlay: false,
          showHeader: true,
          showFooter: true,
          showMenu: false,
          isAddExtraClass: false,
          activeIndex: '/mobile/home',
          searchInput: '',
          showSearchInput: '',
          isShowSearch: false,
          navData: [],
          imgDataUrl: require('/src/assets/img/logo.png'),
          loginModal: {
            visible:false,
            login_error: '',
            isLogin: true,
            isGetYzm: false,
            isVerify: false,
            countdown: '等待 60 s',
            loginForm: {
              tel: '',
              pwd: '',
              verify: '',
              autoLogin: true,
            },
            register_error: '',
            register_sms_key: '',
            register_sms_image: '',
            registerForm: {
              register_tel: '',
              register_pwd: '',
              image_yzm: '',
              yzm: '',
              yzm_placeholder: '请输入短信验证码',
              agree: false,
            },
          },
          forgetPwdModal: {
            error: '',
            visible: false,
            isGetYzm: false,
            isVerify: false,
            countdown: '等待 60 s',
            countdowntime: 60,
            sms_key: '',
            sms_image: '',
            form: {
              forget_tel: '',
              image_yzm: '',
              yzm: '',
              yzm_placeholder: '请输入短信验证码',
              pwd: '',
              verify: '',
            }
          },
          addCellPhoneModal: {
            error: '',
            visible: false,
            isGetYzm: false,
            isVerify: false,
            countdown: '等待 60 s',
            sms_key: '',
            sms_image: '',
            form: {
              addtel: '',
              image_yzm: '',
              yzm: '',
              yzm_placeholder: '请输入短信验证码',
              verify: '',
              token: '',
              target: '',
              user_id: ''
            }
          },
          rules: {
            register_tel: [
              { required: true, validator: checkPhone, message: '请输入手机号', trigger: 'onBlur' },
              { validator: checkPhoneExistRule, trigger: 'onBlur' }
            ],
            register_pwd: [
              { required: true, validator: checkPassword, message: '请输入密码', trigger: 'onBlur' },
            ],
            image_yzm: [
              { required: true, message: '请输入图形验证码', trigger: 'onBlur' },
            ],
            yzm: [
              { required: true, message: '请输入验证码', trigger: 'onBlur' },
            ],
            verify: [
              { required: true, message: '请进行滑动验证', trigger: 'onBlur' },
            ],
            agree: [
              { required: true, message: '请同意协议', trigger: 'onBlur' },
            ],

            tel: [
              { required: true, message: '请填写账号', trigger: 'onBlur' },
            ],
            pwd: [
              { required: true, message: '请输入密码', trigger: 'onBlur' },
              { validator: checkPassword, trigger: 'onBlur' }
            ],

            addtel: [
              { required: true, validator: checkPhone, message:'请输入手机号', trigger: 'onBlur' },
            ],

            forget_tel: [
              { required: true, validator: checkPhone, message:'请输入手机号', trigger: 'onBlur' },
              { validator: checkPhoneNotExistRule, trigger: 'onBlur' }
            ]
          },
          user:{
            is_authenticated: false,
            user_id: null,
            user_name: null,
            cellphone: null,
          },
          resetModalVisible: false,
          cartItemCount: 0,
          reasonTime: null,
          checkLoginTime: null,
          notValidate: false,
          useCookie: true,
          domainSite: 'https://www.fnedu.com',
        }
    },
    created() {
        this.load_user_status()
        this.load_domain_site()
    },
    mounted() {
      const routePath = routePathHandler(this.$route.path);
      if(this.$route.path.indexOf('/custom/') >= 0 && this.$route.params.nav_url != undefined){
        this.activeIndex = '/mobile/custom/' + this.$route.params.nav_url
      }
      else {
        this.activeIndex = routePath;
      }
      window.newThirdBindCellphone = this.newThirdBindCellphone;
      window.showLoginMessage = this.showThirdBindMessage;
    },
    methods: {
      loginClickRightHandler() {
        this.loginModal.isLogin = !this.loginModal.isLogin
        if(!this.loginModal.isLogin) {
          this.getImageCaptcha((sms_key, img_src) => {
            this.loginModal.register_sms_key = sms_key
            this.loginModal.register_sms_image = img_src
          })
        }
      },
      showSearch() {
        this.isShowSearch = true;
        this.showMenu = false;
        const that = this
        setTimeout(function (){
          that.$refs.searchCur.focus()
        }, 200)
        if(this.$route.name === 'CourseSearch'){
          this.searchInput = this.showSearchInput
        }
      },
      onSearch() {
        this.$toast('搜索')
        let query = replaceAll(this.searchInput, '&', '%26')
        this.$router.push('/mobile/course/search/?query=' + query)
      },
      userCommandHandler(val) {
        if(val === 'center') {
          this.goPath('/center/account');
        }
        if(val === 'repwd') {
          this.showResetPwdModal();
        }
        if(val === 'logout') {
          this.logOutOpt();
        }
      },
      load_domain_site() {
        getDomainSite().then(res => {
          if(res.code == 0){
            this.domainSite = res.domain_site
          }
        })
      },
      async load_user_status(){
        let data = {"need_nav": true}
        if(this.$route.name == 'CustomPage' && this.$route.query.preview){
          let nav_url = this.$route.params.nav_url.join('/')
          data['now_url'] = nav_url
        }
          await GetUserState(data).then((res) => {
              if (res.id) {
                this.user.is_authenticated = true;
                this.user.user_id = res.id;
                this.user.user_name = res.username;
                this.user.cellphone = res.cellphone;
                this.addCellPhoneModal.form.user_id = res.id;
                this.loadCartItemCount();
                if (res.avatar) {
                  this.imgDataUrl = res.avatar;
                }
                this.reasonTime = setInterval(this.checkUserLogin, 10000);
              } else {
                this.checkLoginTime = setInterval(this.checkUserHasLogin, 10000);
              }
            this.navData = res.nav;

            if (res.notValidate) {
              this.notValidate = true;
            }

            if (res.need_retain) {
              this.loginModal.loginForm.autoLogin = true;
            } else {
              this.loginModal.loginForm.autoLogin = false;
            }

            if (this.user.is_authenticated && !this.user.cellphone) {
              this.addCellPhoneModal.visible = true;
            }
          }).catch(error => {
              this.$http.get('/data/front/nav.json').then(res => {
                this.user.is_authenticated = true;
                this.user.user_id = '0000000000000';
                this.user.user_name = '纯VUE前端用户';
                this.navData = res.data.sites;
              }).catch(error => {
                showMessage(error)
              });
          });
      },
      getImageCaptcha(callback) { //获取图片验证码
        getSmsCheck().then(res => { 
          const img_src = res.result === 0 ? `data:image/png;base64,${res.captcha_base64_img}` : '';
          const sms_key = res.result === 0 ? res.sms_key : '';

          if(callback && typeof callback === 'function') {
            callback(sms_key, img_src)
          }
        }).catch(err => {});
      },
      // 登录状态中的定时任务
      checkUserLogin() {
        let that = this;
        updateUserLoginState().then((res) => {
          if (res.hasOwnProperty("error") && res.error === 'Not Login State') {
            clearInterval(that.reasonTime)
            if (!that.loginModal.visible) {
              if (res.reason) {
                let msg = `${res.reason}`
                showConfirmMessageBox(msg).then(() => {
                  that.userLogoutByOther();
                }).catch(res => {})
                setTimeout(function (){that.userLogoutByOther()},3000);
              } else {
                that.userLogoutByOther();
              }
            }
          }
        }).catch(error => {

        });
      },

      checkUserHasLogin() {
        let that = this;
        updateUserLoginState().then((res) => {
          if (res.hasOwnProperty("result") && res.result === 0) {
            clearInterval(that.checkLoginTime)
            that.load_user_status()
          }
        }).catch(error => {

        });
      },

      userLogoutByOther() {
        if (window.need_login) {
          window.location.href = "/mobile/login/?next=" + window.location.pathname;
        } else {
          this.$router.go(0);
        }
      },

      // 第三方登录
      startThirdPartyLogin(type) {
        updateUserLoginState().then((res) => {
          if (res.hasOwnProperty("error") && res.error === 'Not Login State') {
            if(type == 'qq'){
              let next = location.pathname;
              var redirect_uri = this.domainSite + '/mobile/login_success/qq-oauth2/qq-callback?target=' + next
              var url = 'https://graph.qq.com/oauth2.0/authorize?client_id=101196615&response_type=token&redirect_uri=' + encodeURIComponent(redirect_uri);
              location.href = url
              // QC.Login.showPopup({
              //   appId: '101196615',
              //   // redirectURI: 'http://127.0.0.1:8080/mobile/login_success/qq-oauth2/qq-callback?target=' + next
              //   redirectURI: 'https://www.fnedu.com/user/social-login/qq-oauth2/qq-callback?target=' + next
              // })
            }
            else {
              ThirdPartyLogin(type, '', 'mobile')
            }
          } else {
            this.$router.go(0);
          }
        }).catch(error => {
        });
      },
      newThirdBindCellphone(token, target_url) {
        this.addCellPhoneModal.form.token = token;
        this.addCellPhoneModal.form.target = target_url;
        this.loginModal.visible = false;
        this.addCellPhoneModal.visible = true;
        this.getImageCaptcha((sms_key, img_src) => {
          this.addCellPhoneModal.sms_key = sms_key
          this.addCellPhoneModal.sms_image = img_src
        })
      },
      showThirdBindMessage(message) {
        showMessage(message)
      },
      getAddSms() {
        this.$refs.addCellPhoneForm.validate(['addtel', 'image_yzm']).then(() => {
          // this.addCellPhoneModal.isVerify = true;
          SendSms(this.addCellPhoneModal.form.register_tel, this.addCellPhoneModal.sms_key, this.addCellPhoneModal.form.image_yzm).then((res) => {
            if (!res.result){
              this.addCellPhoneModal.form.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getAddPhoneYzm();
            } else {
              this.getImageCaptcha((sms_key, img_src) => {
                this.addCellPhoneModal.sms_key = sms_key
                this.addCellPhoneModal.sms_image = img_src
              })
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }).catch(err=>{});
      },
      getAddPhoneStatus(val) {
        // 判断图形校验是否成功
        if(val) {
          this.addCellPhoneModal.form.verify = 'success';
        } else {
          this.addCellPhoneModal.form.verify = '';
        }
      },
      getAddPhoneResult(val) {
        this.getAddPhoneStatus(val)
        if(val === 'success') {
          // 图形校验成功
          this.addCellPhoneModal.isVerify = false;
          SendSms(this.addCellPhoneModal.form.addtel).then((res) => {
            if (!res.result){
              this.addCellPhoneModal.form.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getAddPhoneYzm();
            } else {
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }
      },
      getAddPhoneYzm(surplus_time) {
        // 展示等待时间
        this.addCellPhoneModal.isGetYzm = true;
        let time = surplus_time ? surplus_time : 60;
        const countdown = setInterval(() => {
          if(time > 0) {
            time --;
            this.addCellPhoneModal.countdown = `等待 ${ time } s`
          } else {
            clearInterval(countdown);
            this.addCellPhoneModal.isGetYzm = false;
            this.addCellPhoneModal.countdown = `等待 60 s`;
          }
        }, 1000)
      },
      submitAddPhoneForm() {
        this.$refs.addCellPhoneForm.validate().then(() => {
          AddCellPhone(this.addCellPhoneModal.form).then((res) => {
            if (!res.result) {
              // this.loginModal.visible = false;
              if (this.user.is_authenticated) {
                  this.user.cellphone = true;
                  this.addCellPhoneModal.visible = false;
              } else {
                this.$router.go(0);
              }
            } else {
              this.getImageCaptcha((sms_key, img_src) => {
                this.addCellPhoneModal.sms_key = sms_key
                this.addCellPhoneModal.sms_image = img_src
              })
              this.addCellPhoneModal.error = res.msg;
            }
          }).catch(err => {
            showMessage('服务异常，请稍后再试');
          });
        }).catch(err=>{});
      },
      closeAddPhoneModal() {
        this.addCellPhoneModal.error = '';
        this.$refs.addCellPhoneForm.resetValidation();
        if (this.user.is_authenticated && !this.user.cellphone) {
          this.logOutOpt();
        }
      },
      closeLoginModal() {
        this.loginModal.login_error = "";
        this.loginModal.register_error = "";
        this.loginModal.isVerify = false;
        if (this.loginModal.isLogin) {
          this.$refs.loginForm.resetValidation();
        } else {
          this.$refs.registerForm.resetValidation();
        }
        this.loginModal.isLogin = true;
      },
      openRegister() {
        this.loginModal.login_error = "";
        this.$refs.loginForm.resetValidation();
        this.loginModal.isLogin = false;
        this.loginModal.isVerify = false
      },
      openLogin() {
        this.loginModal.register_error = "";
        this.$refs.registerForm.resetValidation();
        this.loginModal.isLogin = true;
        this.loginModal.isVerify = false
      },

      // 忘记密码
      showForgetPwd() {
        this.getImageCaptcha((sms_key, img_src) => {
          this.forgetPwdModal.sms_key = sms_key
          this.forgetPwdModal.sms_image = img_src
        })
        this.loginModal.visible = false;
        this.forgetPwdModal.visible = true;
      },
      getForgetSms() {
        this.$refs.forgetPwdForm.validate(['forget_tel', 'pwd', 'image_yzm']).then(() => {
          // this.forgetPwdModal.isVerify = true;
          SendSms(this.forgetPwdModal.form.forget_tel, this.forgetPwdModal.sms_key, this.forgetPwdModal.form.image_yzm).then(res => {
            if (!res.result){
              this.forgetPwdModal.form.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getForgetYzm();
            } else {
              this.getImageCaptcha((sms_key, img_src) => {
                this.forgetPwdModal.sms_key = sms_key
                this.forgetPwdModal.sms_image = img_src
              })
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }).catch(err=>{});
      },
      getForgetPwdStatus(val) {
        // 判断图形校验是否成功
        if(val) {
          this.forgetPwdModal.form.verify = 'success';
        } else {
          this.forgetPwdModal.form.verify = '';
        }
      },
      getForgetPwdResult(val) {
        this.getForgetPwdStatus(val)
        if(val === 'success') {
          // 图形校验成功
          this.forgetPwdModal.isVerify = false;
          SendSms(this.forgetPwdModal.form.forget_tel).then((res) => {
            if (!res.result){
              this.forgetPwdModal.form.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getForgetYzm(this.forgetPwdModal.countdowntime);
            } else {
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }
      },
      getForgetYzm(surplus_time) {
        // 展示等待时间
        this.forgetPwdModal.isGetYzm = true;
        let time = surplus_time ? surplus_time : 60;
        if (time < 60) { return }
        const countdown = setInterval(() => {
          if(time > 0) {
            time --;
            this.forgetPwdModal.countdown = `等待 ${ time } s`
            this.forgetPwdModal.countdowntime = `${ time }`
          } else {
            clearInterval(countdown);
            this.forgetPwdModal.isGetYzm = false;
            this.forgetPwdModal.countdown = `等待 60 s`;
            this.forgetPwdModal.countdowntime = 60
          }
        }, 1000)
      },
      submitForgetForm() {
        this.$refs.forgetPwdForm.validate().then(() => {
          ForgetPWD(this.forgetPwdModal.form)
            .then((res) => {
              if (!res.result) {
                this.forgetPwdModal.visible = false;
              } else {
                this.getImageCaptcha((sms_key, img_src) => {
                  this.forgetPwdModal.sms_key = sms_key
                  this.forgetPwdModal.sms_image = img_src
                })
                this.forgetPwdModal.error = res.msg;
              }
            }).catch((err) => {
            showMessage('服务异常，请稍后再试');
          })
        }).catch(err=>{
          return false
        });
      },
      closeForgetPwdModal() {
        this.forgetPwdModal.error = '';
        this.forgetPwdModal.visible = false;
        this.forgetPwdModal.isGetYzm = false;
        this.forgetPwdModal.isVerify = false;
        this.$refs.forgetPwdForm.resetValidation();
      },

      // 注册
      getSms() {
        this.$refs.registerForm.validate(['register_tel', 'register_pwd', 'image_yzm']).then(() => {
          SendSms(this.loginModal.registerForm.register_tel, this.loginModal.register_sms_key, this.loginModal.registerForm.image_yzm).then(res => {
            if (!res.result){
              this.loginModal.registerForm.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getYzm();
            } else {
              this.getImageCaptcha((sms_key, img_src) => {
                this.loginModal.register_sms_key = sms_key
                this.loginModal.register_sms_image = img_src
              })
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }).catch(err=>{});
        // 点击获取验证码，先弹出图形校验
        // this.$refs.registerForm.validate(['register_tel', 'register_pwd']).then(() => {
        //   this.loginModal.isVerify = true;
        // }).catch(err=>{
        // });
      },
      getRegisterStatus(val) {
        // 判断图形校验是否成功
        if(val) {
          this.loginModal.registerForm.verify = 'success';
        } else {
          this.loginModal.registerForm.verify = '';
        }
      },
      getRegisterResult(val) {
        this.getRegisterStatus(val)
        if(val === 'success') {
          // 图形校验成功
          this.loginModal.isVerify = false;
          SendSms(this.loginModal.registerForm.register_tel).then((res) => {
            if (!res.result){
              this.loginModal.registerForm.yzm_placeholder = `请输入短信验证码 (序列号：${res.serial})`;
              this.getYzm();
            } else {
              showMessage(res.msg)
            }
          }).catch((error) => {
            showMessage('服务异常，请稍后再试')
          });
        }
      },
      getYzm(surplus_time) {
        // 展示等待时间
        this.loginModal.isGetYzm = true;
        let time = surplus_time ? surplus_time : 60;
        const countdown = setInterval(() => {
          if(time > 0) {
            time --;
            this.loginModal.countdown = `等待 ${ time } s`
          } else {
            clearInterval(countdown);
            this.loginModal.isGetYzm = false;
            this.loginModal.countdown = `等待 60 s`;
          }
        }, 1000)
      },
      submitRegisterForm() {
        this.loginModal.register_error = '';
        this.$refs.registerForm.validate().then(() => {
            RegisterUser(this.loginModal.registerForm)
              .then((res) => {
                if (!res.result) {
                  // this.loginModal.visible = false;
                  this.$router.go(0);
                } else {
                  this.getImageCaptcha((sms_key, img_src) => {
                    this.loginModal.register_sms_key = sms_key
                    this.loginModal.register_sms_image = img_src
                  })
                  this.loginModal.register_error = res.msg
                }
              }).catch((err) => {
              showMessage('服务异常，请稍后再试');
            })
        }).catch(err=>{
          return false
        });
      },

      getLoginStatus(val) {
        if(val) {
          this.loginModal.loginForm.verify = 'success';
        } else {
          this.loginModal.loginForm.verify = '';
        }
      },
      getLoginResult(val) {
        this.getLoginStatus(val)
        if(val === 'success') {
          this.loginModal.isVerify = true;
         // this.$refs.loginForm.clearValidate('verify');
        }
      },
      submitLoginForm() {
        this.loginModal.login_error = '';
        if(!this.useCookie){
          return false
        }
        if(this.notValidate) {
          LoginUser(this.loginModal.loginForm)
            .then((res) => {
              if (!res.result) {
                this.$router.go(0);
              } else {
                this.loginModal.login_error = res.msg
              }
            }).catch((err) => {
              showMessage('服务异常，请稍后再试')
          })
        } else {
          this.$refs.loginForm.validate().then(() => {
              LoginUser(this.loginModal.loginForm)
                .then((res) => {
                  if (!res.result || res.result == 0) {
                    this.$router.go(0);
                  } else {
                    this.loginModal.login_error = res.msg
                  }
                }).catch((err) => {
                  showMessage('服务异常，请稍后再试')
              })
          }).catch(err=>{
            return false
          });
        }
      },
      canUseCookie(){
        setCookie('fnedu_test_cookie', 1)
        let test = getCookie('fnedu_test_cookie')
        if(test && test == 1){
          this.useCookie = true
        }
        else{
          this.useCookie = false
        }
      },
      showResetPwdModal() {
        this.resetModalVisible = true;
      },

      logOutOpt() {
        LogOutUser().then((res) => {
          if (window.need_login) {
            window.location.href = "/mobile/home";
          } else {
            window.location.reload();
          }
        }).catch((err) => {
          showMessage('服务异常，请稍后再试')
        })
      },
      goPath(path) {
        this.$router.push(path);
      },

      // cart
      loadCartItemCount(){
        countCartItems({'owner_id': this.user.user_id}).then(result => {

          if (result.succeed) {
            if (result.count > 0) {
              this.cartItemCount = result.count;
            } else {
              this.cartItemCount = 0;
            }

          }

        }).catch(err => {
        });
      },
      toCenterPage(){
        if(this.showMenu === true) {
          this.showMenu = false
        }
        this.goPath('/mobile/center')
      },
      goNav(nav) {
        this.showMenu = false;
        if (nav.open_mode != undefined || nav.open_mode) {
          clickNav(nav.id).then(res => {
          })
        }
        if(nav.open_mode == 2){
          if(nav.link_url){
            window.open(nav.link_url)
          }
          else {
            window.open('/mobile' + nav.path)
          }
        }
        else {
          if(nav.link_url){
            location.href = nav.link_url
          }
          else {
            this.$router.push('/mobile' + nav.path)
          }
        }
      }
    },
    watch: {
      '$route' (to, from) {
          this.showMenu = false;
          this.activeIndex = to.path;
      },
      loginVisible: {
        handler(val) {
          this.loginModal.visible = val;
          this.canUseCookie()
        },
        deep: true
      },
      'loginModal.visible':{
        handler(val) {
          this.canUseCookie()
        },
        deep: true
      },
      cartItemCount:{
        handler(val) {

          if (val > 0) {
            this.cartItemCount = val;
          } else {
            this.cartItemCount = '';
          }

        },
        deep: true
      },
      searchInput(val) {
        this.showSearchInput = this.searchInput
      }
    },
}
</script>

<style lang="scss" scoped>
  #header {
    height:60px;
    border-bottom:1px solid #f3f4f5;
    z-index:20;
    background:#fff;
    position:fixed;
    left:0;
    right:0;
    top:0;
    .header {
      height:100%;
      display:flex;
      align-items: center;
      .left {
        padding-left:10px;
        padding-right:10px;
        min-width:140px;
        img {
          height:30px;
        }
      }
      .right {
        flex: 1;
        display:flex;
        justify-content: flex-end;
        align-items: center;
        .search, .cart {
          padding-left:10px;
          padding-right:10px;
        }
        .login {
          margin-left:10px;
        }
        .avatar {
          margin-left:10px;
        }
        .menu {
          padding-left:20px;
          padding-right:20px;
        }
      }
    }
    &.extra_class {
      border-bottom-color:#009dd9;
      .header {
        background:#009dd9;
        .right {
          color:#fff;
          .van-search {
            background:transparent;
            .van-search__action {
              color:#fff;
            }
          }
        }
      }
    }
  }
  .menu_list {
    overflow-x:hidden;
    overflow-y:auto;
    position:fixed;
    top:60px;
    left:0;
    right:0;
    bottom:0;
    background:#fff;
    padding:0 10px;
    z-index:10;
    ul {
      li {
        border-bottom:1px solid #e6e6e6;
        a {
          display:block;
          color:#676767;
          padding-top:15px;
          padding-bottom:15px;
        }
        &.active {
          a {
            color:#00adef;
          }
        }
      }
    }
  }
  .main {
    min-height: calc(100vh - 57px);
    padding-top: 60px;
    &.full_h {
      min-height:calc(100vh);
    }
  }
  #footer {
    background-color: #212121;
    border-top: 1px solid #444444;
    color:#fff;
    padding:10px;
    font-size:12px;
    text-align:center;
    line-height:1.5;
    > a {
      color:#00adef;
    }
  }
  :deep(.log_form) {
    padding-top:20px;
    .van-cell-group {
      .van-cell {
        .van-field__control {
          height: 40px;
          background: #f3f3f3;
          border-radius: 4px;
          padding-left: 10px;
        }
        &:after {
          display:none;
        }
        &.extra {
          font-size:12px;
          .van-checkbox__label {
            color:#666;
          }
          .van-button {
            height:40px;
          }
          .agreement {
            padding:10px 0;
          }
        }
        &.slider_verify {
          .van-field__control {
            padding:0;
          }
        }
        &.custom_van_checkbox{
          .van-field__control {
            background: #fff;
          }
        }
      }
      .field_tel {
        .van-cell__title {
          position: absolute;
          left: 26px;
          z-index: 1;
          top: 18px;
          width: auto;
          padding-right: 10px;
          border-right: 1px solid #ccc;
        }
        .van-field__control {
          padding-left:75px;
        }
      }
      .field_image_yzm {
        .van-field__button {
          img {
            display: block;
            width: 80px;
            height: 40px;
          }
        }
      }
      &:after {
        display:none;
      }
    }
  }
  .third_login {
    position: relative;
    text-align: center;
    > a {
      > i{
        margin-left:15px;
        margin-right:15px;
        font-size:40px;
      }
    }
  }

</style>
